module.exports = __webpack_public_path__ + "static/media/team-member-05.2d3cb1ca.jpg";